import { inject, Injectable } from "@angular/core";

import { Observable, catchError, take } from "rxjs";

import { HttpClient } from "@angular/common/http";
import { UrlBuilder } from "@venecia/builders";
import { ConfigService } from "@venecia/services";

import { RequestOptions, ApiResponse, TemplateHelper } from "../base";
import { UserIdentity } from "./model/user-identity.model";

@Injectable({ providedIn: 'root' })
export class UserIdentityApi {

    private readonly http = inject(HttpClient);
    private readonly configService = inject(ConfigService);

    protected urlBuilder?: UrlBuilder;

    constructor() {
        const baseUrlKey = 'http.rest.auth.url';
        const basePath = '/api/identity';
        this.configService
            .select(baseUrlKey)
            .pipe(take(1))
            .subscribe((value: string) => {
                this.urlBuilder = new UrlBuilder(value, basePath);
            });
    }

    me(options?: RequestOptions): Observable<ApiResponse<UserIdentity>> {
        const url = this.urlBuilder!.build("/me");
        const httpOptions = TemplateHelper.buildOptions(options);

        return this.http
            .get<ApiResponse<UserIdentity>>(url, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }
}